/* Narrow progressive enhancement for HP's own native Forms embeds. */
(function () {
  'use strict';
  var kinds = {
    company: ['company_name', 'first_name', 'last_name', 'email', 'phone_number'],
    guest_quote: ['first_name', 'email', 'custom#company', 'custom#delivery_address', 'custom#quote_lines'],
    custom: ['first_name', 'email', 'custom#company', 'custom#quantity_pieces', 'custom#requirements_and_dimensions']
  };
  document.querySelectorAll('[data-hp-form-kind]').forEach(function (wrapper) {
    if (wrapper.dataset.hpA11yStarted) return;
    wrapper.dataset.hpA11yStarted = 'true';
    var required = kinds[wrapper.dataset.hpFormKind] || [];
    var german = document.documentElement.lang.toLowerCase().startsWith('de');
    var optional = {
      company: ['company_tax_id', 'custom#company_registration_number_if_applicable'],
      guest_quote: ['custom#notes'],
      custom: ['custom#drawing_or_photo-field', 'custom#additional_drawing_or_photo-field', 'phone_number', 'custom#material', 'custom#desired_timing', 'custom#private_attachment_reference']
    }[wrapper.dataset.hpFormKind] || [];
    try { sessionStorage.setItem('hp-intake-locale-v1', JSON.stringify({ kind: wrapper.dataset.hpFormKind, lang: german ? 'de' : 'en', savedAt: Date.now() })); } catch (_) {}
    var observers = [], observed = new WeakSet(), sequence = 0;
    function enhance(root) {
      if (!observed.has(root)) {
        observed.add(root);
        var observer = new MutationObserver(function () { enhance(root); });
        observer.observe(root, { childList: true, subtree: true });
        observers.push(observer);
      }
      root.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
        if (embed.dataset.hpRequirementHelp) return;
        embed.dataset.hpRequirementHelp = 'true';
        var help = document.createElement('p');
        help.className = 'hp-form-guidance';
        help.textContent = german ? '* Pflichtfeld. Mit „optional“ gekennzeichnete Angaben sind freiwillig.' : '* Required field. Fields marked optional can be left blank.';
        if (wrapper.dataset.hpFormKind === 'company') help.textContent += german ? ' Die Firmenrechnungsadresse ist erforderlich.' : ' The company billing address is required.';
        embed.insertAdjacentElement('beforebegin', help);
      });
      root.querySelectorAll('input, textarea, select').forEach(function (field) {
        if (field.type === 'hidden' || field.type === 'submit' || field.type === 'checkbox') return;
        var key = field.getAttribute('name') || field.id;
        var label = Array.from(root.querySelectorAll('label')).find(function (candidate) {
          return candidate.htmlFor === key || (field.id && candidate.htmlFor === field.id);
        });
        if (label) {
          if (!field.id) field.id = key || 'hp-form-control-' + (++sequence);
          label.htmlFor = field.id;
          if (!label.id) label.id = field.id + '-hp-label';
          if (!field.getAttribute('aria-label') && !field.getAttribute('aria-labelledby')) field.setAttribute('aria-labelledby', label.id);
          // Native Forms uses 50% ink for floating labels. Keep every state readable.
          label.style.color = '#514e48';
          if (field.tagName === 'TEXTAREA') {
            // Native Forms renders its textarea error as a sibling of this
            // exact control wrapper, without connecting it to the textarea.
            var error = field.parentElement && field.parentElement.nextElementSibling;
            var previousError = field.dataset.hpErrorId;
            var descriptions = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
            if (previousError) descriptions.delete(previousError);
            if (error && error.tagName === 'OUTPUT' && error.getAttribute('role') === 'alert' && !error.hidden && error.getAttribute('aria-hidden') !== 'true' && error.textContent.trim()) {
              if (!error.id) error.id = field.id + '-hp-error';
              descriptions.add(error.id);
              field.setAttribute('aria-invalid', 'true');
              field.dataset.hpErrorId = error.id;
            } else if (previousError) {
              field.removeAttribute('aria-invalid');
              delete field.dataset.hpErrorId;
            }
            if (descriptions.size) field.setAttribute('aria-describedby', Array.from(descriptions).join(' '));
            else if (previousError) field.removeAttribute('aria-describedby');
          }
          if (field.type === 'file') {
            // Native file inputs sit inside an empty overlay label. Put optional
            // copy on the visible caption and outline the complete upload area.
            var caption = label.parentElement && label.parentElement.parentElement && label.parentElement.parentElement.querySelector('p');
            if (caption && !caption.dataset.hpRequirement && optional.indexOf(key) !== -1) {
              caption.appendChild(document.createTextNode(' (optional)'));
              caption.dataset.hpRequirement = 'true';
            }
            if (!field.dataset.hpUploadFocus) {
              field.dataset.hpUploadFocus = 'true';
              field.addEventListener('focus', function () { label.style.outline = '2px solid #141414'; label.style.outlineOffset = '3px'; label.style.borderRadius = '8px'; });
              field.addEventListener('blur', function () { label.style.outline = ''; label.style.outlineOffset = ''; });
            }
          } else if (!label.dataset.hpRequirement && (required.indexOf(key) !== -1 || optional.indexOf(key) !== -1)) {
            var suffix = document.createElement('span');
            suffix.textContent = required.indexOf(key) !== -1 ? ' *' : ' (optional)';
            if (required.indexOf(key) !== -1) suffix.setAttribute('aria-hidden', 'true');
            label.appendChild(suffix);
            label.dataset.hpRequirement = 'true';
          }
        }
        if (required.indexOf(key) !== -1) field.setAttribute('aria-required', 'true');
        if (key === 'email') { field.setAttribute('autocomplete', 'email'); field.setAttribute('inputmode', 'email'); }
        if (key === 'first_name') field.setAttribute('autocomplete', 'given-name');
        if (key === 'phone_number') field.setAttribute('autocomplete', 'tel');
      });
      root.querySelectorAll('*').forEach(function (element) { if (element.shadowRoot) enhance(element.shadowRoot); });
    }
    enhance(wrapper);
    // A shadow root can attach without a light-DOM mutation; bounded readiness checks.
    var attempts = 0;
    var timer = setInterval(function () { enhance(wrapper); if (++attempts >= 40) clearInterval(timer); }, 500);
    window.addEventListener('pagehide', function () { clearInterval(timer); observers.forEach(function (o) { o.disconnect(); }); }, { once: true });
  });
})();
